import campaignConfig from '../../../../campaign-config/campaign.json';
import pointsIcon from '../../../../assets/images/pts.png';

export const globalColors = campaignConfig.global?.colors || {};
export const globalText = campaignConfig.global?.text || {};
export const globalImages = campaignConfig.global?.images || {};

const localSharedAssets = {
	'src/assets/images/pts.png': pointsIcon,
};

export const tutorDetailsSharedConfig = campaignConfig.tutor_details?.shared || {};

export const resolveTutorDetailsSharedAsset = (asset) =>
	localSharedAssets[asset] || asset;
